<template lang="pug">
  div.map-icon.map-icon-object
    div.mapIcon
      div(:class="iconClass")
        div.icon-img
        span.icon-point
        div.progress-bar
          div.progress-bar__loaded

</template>

<script>
  import baseMapIconMixin from './base-map-icon-mixin.js'
  import {STATUS_ACTIVE, STATUS_PLANED} from "../../config/config";

  export default {
    mixins: [ baseMapIconMixin ],
    name: 'map-icon-object',
    data () {
      return {
        fields: {}
      }
    },
    props: {
      iconType: {
        type: String,
        default: 'garbage'
      },
      iconSubType: {
        type: String,
        default: 'garbage'
      },
      progress: {
        type: Number,
        default: 0
      }
    },
    computed: {
      iconClass() {
        let iC = 'icon icon--' + this.iconType
        iC += ' icon--' + this.iconSubType
        let status = ' active'
        if (this.fields.hasOwnProperty('status_id')) {
          if (this.fields.status_id == STATUS_ACTIVE) {
            status = ' active'
          } else if (this.fields.status_id == STATUS_PLANED) {
            status = ' planned'
          } else {
            status = ' inactive'
          }
        }
        iC += status

        return iC
      }
    },
    methods: {
      injectConf (options = {}) {
        let {iconType, iconSubType, model = {}} = options
        this.fields = Object.assign({}, model)
        this.iconType = iconType
        this.iconSubType = iconSubType
        this.registerVueInMap()
      }
    }
  }
</script>
